import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/layouts/DashboardLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Shield, Clock, CheckCircle2 } from "lucide-react";
import { TaxReturnForm } from "@/components/tax-return/TaxReturnForm";
import { ServiceWarningBanner } from "@/components/tax-return/components/ServiceWarningBanner";

export default function TaxReturn() {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Tax Return Request - Numberz Insight | Professional Tax Services</title>
        <meta
          name="description"
          content="Submit your tax return request through our secure platform. Professional tax agents in Melbourne and Launceston."
        />
        <meta
          name="keywords"
          content="tax return, online tax return, tax agent Melbourne, tax agent Launceston, professional tax service"
        />
      </Helmet>

      <div className="container max-w-5xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <ServiceWarningBanner />
        
        {/* Hero Section */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-foreground mb-4">
            Professional Tax Return Service
          </h1>
          <p className="text-xl text-muted-foreground mb-6 max-w-2xl mx-auto">
            Fast, reliable, and accurate tax returns from registered tax agents.
            Choose between online and in-office services.
          </p>
        </div>

        {/* Main Form */}
        <Card>
          <CardHeader>
            <CardTitle>Tax Return Request</CardTitle>
            <CardDescription>
              Complete the form below to begin your tax return process
            </CardDescription>
          </CardHeader>
          <CardContent>
            <TaxReturnForm />
          </CardContent>
        </Card>

        {/* Features Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mt-12">
          <Card className="transition-all duration-300 hover:shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Building2 className="h-5 w-5 text-primary" />
                Expert Tax Agents
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Registered tax agents with years of experience
              </p>
            </CardContent>
          </Card>

          <Card className="transition-all duration-300 hover:shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Shield className="h-5 w-5 text-primary" />
                Maximum Returns
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                We ensure you get all eligible deductions
              </p>
            </CardContent>
          </Card>

          <Card className="transition-all duration-300 hover:shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Clock className="h-5 w-5 text-primary" />
                Fast Processing
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Quick turnaround time with efficient processing
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-12">
          <Badge variant="outline" className="px-4 py-2 text-base flex items-center gap-2">
            <Shield className="h-4 w-4" />
            ATO Registered Tax Agent
          </Badge>
          <Badge variant="outline" className="px-4 py-2 text-base flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4" />
            100% Satisfaction Guaranteed
          </Badge>
        </div>
      </div>
    </DashboardLayout>
  );
}